const corsProxyUrl = "https://proxy.marcuth.workers.dev/"

export { corsProxyUrl }